/* eslint-disable max-len */
import React from 'react';

const LayoutSlideshowIcon = props => (
  <svg width={50} height={50} viewBox="0 0 50 50" {...props}>
    <path
      fill="currentColor"
      d="M3 2h44a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v44h44V3H3zm8.32 24.616a.5.5 0 1 1-.64.768l-3-2.5a.5.5 0 0 1 0-.768l3-2.5a.5.5 0 1 1 .64.768L8.781 25.5l2.54 2.116zm27.36-4.232a.5.5 0 1 1 .64-.768l3 2.5a.5.5 0 0 1 0 .768l-3 2.5a.5.5 0 1 1-.64-.768l2.539-2.116-2.54-2.116z"
    />
  </svg>
);

export default LayoutSlideshowIcon;
